/**
 * Determines if two numbers roughly equal each other (if they're difference is less than the
 * epsilon)
 * @param {Number} num1
 * @param {Number} num2
 * @param {Number} [epsilon=0.0001]: Max difference allowed before returning false
 * @return {Boolean}
 */
function closelyEqual(num1, num2, epsilon = 0.0001) {
  return Math.abs(num1 - num2) < epsilon;
}

/**
 * Does an equality check on the center arrays and zoom values of each viewport
 * @param {Object} v1: viewport object containing center and zoom keys
 * @param {Object} v2: viewport object containing center and zoom keys
 * @return {Boolean}
 */
export function equalViewports(v1, v2) {
  return (
    v1.zoom === v2.zoom &&
    closelyEqual(v1.center[0], v2.center[0]) &&
    closelyEqual(v1.center[1], v2.center[1])
  );
}
